const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// AfterShip Returns line item properties
const AFTERSHIP_PROPERTIES = {
  ENABLE_FINAL_SALE_PROPERTY: true,
  FINAL_SALE_KEY: '_ASRC',
  FINAL_SALE_VALUE: 'Final Sale'
};
